import React, { useEffect, useState } from 'react';
import { SubHeading } from '../../components';

import { images } from '../../constants';
import './Products.css';


const Products = () => {
  
  const [product1, setProduct1] = useState(false);
  const [product2, setProduct2] = useState(false);
  const [product3, setProduct3] = useState(false);

  function onScroll() {
    
    if(window.scrollY >= 1600) {
      setProduct1(true);
    }else {
      setProduct1(false);
    }

    if(window.scrollY >= 2100) {
      setProduct2(true);
    }else {
      setProduct2(false);
    }

    if(window.scrollY >= 2600) {
      setProduct3(true);
    }else {
      setProduct3(false);
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return ()=> {
      window.removeEventListener("scroll", onScroll);
    }
  }, [])

  return (
      <div className='app__products app__bg flex__center section__padding' id="products">
        <div className="app__products-title">
          <SubHeading title="Accessories That Make You Shine"/>
          <h1 className="headtext__italiana">Brand New Products</h1>
        </div>

        <div className="app__products-content flex__center">
          <ul className='app__products-item-container'>
            <li className={product1 ? "product-animation" : "app__products-item"}>
              <img src={images.product01} alt="product01" />
              <div className="app__products-info">
              <h3 className='app__products-info-title'>Two-Tone Diamond Ring</h3>
              <img src={images.leaf} alt="leaf" />
              <p className='app__products-info-p'>24k two-toned Diamond Engagement Ring.<br/> Handcrafted by Head Designer Laura Gold.<br/> Made with the finest materials in Greece.<br/> For your once in a Lifetime Proposal.</p>
              </div>
            </li>

            <li className={product2 ? "product-animation-reverse" : "app__products-item"}>
              <img src={images.product02} alt="product02" />
              <div className="app__products-info">
              <h3 className='app__products-info-title'>White Gold Diamond Bracelet</h3>
              <img src={images.leaf} alt="leaf" />
              <p className='app__products-info-p'>24k White Gold Diamond Bracelet.<br/> Handcrafted by Head Designer Laura Gold.<br/> Made with the finest materials in Greece.<br/> Special Gift for your Special someone.</p>
              </div>
            </li>

            <li className={product3 ? "product-animation" : "app__products-item"}>
              <img src={images.product03} alt="product03" />
              <div className="app__products-info">
              <h3 className='app__products-info-title'>White Pearl Rose Necklace</h3>
              <img src={images.leaf} alt="leaf" />
              <p className='app__products-info-p'>3.5 carat White Pearl with Diamond Rose<br/> Handcrafted by Head Designer Laura Gold.<br/> Made with the finest materials in Greece.<br/> Special Gift for your Special someone.</p>
              </div>
            </li>
          </ul>
        </div>

      </div>
  );
}


export default Products;
